

























































import Vue from 'vue';
import {
  Component, Inject, Watch, Prop,
} from 'vue-property-decorator';
import { DataTableHeader } from 'vuetify';
import { mapState } from 'vuex';
import { Alert, NoticeClass, AuthStore } from '@kasasa/fbase-components/lib';
import {
  GrantResource, Grant, GrantDebit, Transaction,
} from '@/api/grant';
import { Account } from '@/api/consumeraccountdetails';

interface RefundTableEntry {
  postedDate: number | null;
  description: string;
  amount: string;
  transactionCode: string;
  amountRefunded: string;
}

@Component({
  computed: mapState(['fiId']),
})
export default class TunesRefundsSheet extends Vue {
  @Prop({ default: false }) value!: boolean;

  @Prop() qualStartDate!: string;

  @Prop() qualEndDate!: string;

  @Prop() account!: Account;

  @Prop() relationship!: string;

  show: boolean = false;

  fiId!: string;

  loading: boolean = true;

  entries: RefundTableEntry[] = [];

  @Inject('GrantResource')
  grantResource!: GrantResource;

  headers: DataTableHeader[] = [
    { text: 'Posted Date', value: 'postedDate' },
    { text: 'Description', value: 'description' },
    { text: 'Amount', value: 'amount' },
    { text: 'Transaction Code', value: 'transactionCode' },
    { text: 'Amount Refunded', value: 'amountRefunded' },
  ];

  mounted() {
    this.show = this.value;
    if (this.show) {
      this.loadData();
    }
  }

  @Watch('value')
  onNewValue() {
    this.show = this.value;
    if (this.show) {
      this.loadData();
    } else {
      // Clear out the table when closed so that when re-opened we're scrolled to the top
      this.entries = [];
    }
  }

  onShowToggle(newValue: boolean) {
    this.show = newValue;
    this.$emit('input', this.show);
  }

  loadData() {
    this.loading = true;
    this.entries = [];

    const grantDebits: GrantDebit[] = [];
    this.grantResource
      .getGrantsByAccountAndQualDates(
        this.fiId,
        this.account.accountKasasaKey,
        this.qualStartDate,
        this.qualEndDate,
      )
      .then((grants: Grant[]) => {
        grants.forEach((grant: Grant) => {
          grant.grantDebits.forEach((debit: GrantDebit) => {
            grantDebits.push(debit);
          });
        });

        this.generateTableEntriesFromDebits(grantDebits);
      })
      .catch((error: any) => {
        this.showErrorMessage(error);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  generateTableEntriesFromDebits(debits: GrantDebit[]) {
    const sortedDebits: GrantDebit[] = debits.sort(
      (d1: GrantDebit, d2: GrantDebit) => new Date(d1.transactionPostingDate).getTime()
        - new Date(d2.transactionPostingDate).getTime(),
    );

    const newEntries: RefundTableEntry[] = [];
    sortedDebits.forEach((debit: GrantDebit) => {
      newEntries.push({
        postedDate: new Date(debit.transactionPostingDate).getTime(),
        description: debit.transactionDescription,
        amount: `$${debit.transactionAmount}`,
        transactionCode: debit.transaction
          ? debit.transaction.transactionCode
          : '?',
        amountRefunded: `$${debit.amount}`,
      });
    });
    this.entries = newEntries;
  }

  showErrorMessage(error: string) {
    const al = new Alert(error, NoticeClass.ERROR);
    al.setTimeout(5000);
    this.$store.dispatch('notices/add', al);
  }
}
